import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { useAuthStore } from '../store/authStore';
import { usePermissions } from './usePermissions';

/**
 * D-274b — the id of the hidden "עבודה פנימית" engagement (tasks "ישירות תחת OTE").
 * Same query key as useInternalOrgId / the task picker, so nothing extra is fetched.
 */
export function useInternalEngagementId(): string | null {
  const isStaff = useAuthStore((s) => s.user?.role === 'admin' || s.user?.role === 'agent');
  const { internalOnly, internalWorkEngagementId } = usePermissions();
  const q = useQuery({
    queryKey: ['engagements', 'internal-work'],
    queryFn: () => api.getInternalWork(),
    staleTime: 5 * 60_000,
    enabled: isStaff && !internalOnly,
  });
  return internalOnly ? internalWorkEngagementId : q.data?.data?.engagement_id ?? null;
}
